import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { knowledgeApi, type MemoryObject } from '../../api/knowledge';

export function MemoryViewerPage() {
  const [memories, setMemories] = useState<MemoryObject[]>([]);
  const [error, setError] = useState('');

  useEffect(() => {
    void knowledgeApi.listMemories().then(setMemories).catch((e) => setError(String(e)));
  }, []);

  return (
    <div className="mx-auto max-w-4xl p-6">
      <Link to="/knowledge" className="text-sm text-slate-600 hover:underline dark:text-slate-400">← Knowledge Center</Link>
      <h1 className="mt-2 text-2xl font-semibold">Memory Viewer</h1>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <ul className="mt-6 space-y-3">
        {memories.map((m) => (
          <li key={m.id} className="rounded-lg border p-4 dark:border-slate-700">
            <span className="rounded bg-slate-100 px-2 py-0.5 text-xs dark:bg-slate-800">{m.kind}</span>
            <p className="mt-2 text-sm">{m.content}</p>
            {m.outcome && <p className="mt-1 text-xs text-slate-500">Outcome: {m.outcome}</p>}
          </li>
        ))}
        {memories.length === 0 && <li className="text-sm text-slate-500">No memories stored</li>}
      </ul>
    </div>
  );
}
